module.exports = {
  US: p => p.replace(/\s/g, '-').trim(),
  GB: p => p.toUpperCase().trim(),
  CA: p => p.replace(/-/g, ' ').toUpperCase().trim(),
};
